// src/services/CountryService.js
import api from "./api";

export function getIntake(page = 1, limit = 10) {
    return api.get(
        `/intake?page=${page}&limit=${limit}&list=all`
    );
}
